import ScorePage from './ScorePage.vue';
export default ScorePage;
